import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from './components/Layout';

import Home from './pages/Home';
import Resenas from './pages/Resenas';
import ReviewDetail from './pages/ReviewDetail';
import QueLeer from './pages/QueLeer';
import PostDetail from './pages/PostDetail';
import ViajesLiterarios from './pages/ViajesLiterarios';
import FeriasEventos from './pages/FeriasEventos';
import Podcast from './pages/Podcast';
import Libros from './pages/Libros';
import LibroDetail from './pages/LibroDetail';
import Autores from './pages/Autores';
import AutorDetail from './pages/AutorDetail';
import Colaboraciones from './pages/Colaboraciones';
import TrabajaConmigo from './pages/TrabajaConmigo';
import MediaKit from './pages/MediaKit';
import SobreMi from './pages/SobreMi';
import Contacto from './pages/Contacto';
import Buscar from './pages/Buscar';
import AvisoLegal from './pages/legal/AvisoLegal';
import Privacidad from './pages/legal/Privacidad';
import Cookies from './pages/legal/Cookies';
import CondicionesUso from './pages/legal/CondicionesUso';
import PoliticaEditorial from './pages/legal/PoliticaEditorial';
import PoliticaColaboraciones from './pages/legal/PoliticaColaboraciones';
import NotFound from './pages/NotFound';

import { ADMIN_BASE_PATH } from './pages/admin/adminBasePath';
import './App.css';

// El panel de administracion (y el editor de texto enriquecido que carga,
// react-quill) se separa del bundle publico via React.lazy -- ningun
// visitante normal de la web debe pagar ese peso, solo quien entra a /panel.
const AdminLogin = lazy(() => import('./pages/admin/AdminLogin'));
const AdminLayout = lazy(() => import('./pages/admin/AdminLayout'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const AdminAuthorsList = lazy(() => import('./pages/admin/AdminAuthorsList'));
const AdminAuthorForm = lazy(() => import('./pages/admin/AdminAuthorForm'));
const AdminBooksList = lazy(() => import('./pages/admin/AdminBooksList'));
const AdminBookForm = lazy(() => import('./pages/admin/AdminBookForm'));
const AdminReviewsList = lazy(() => import('./pages/admin/AdminReviewsList'));
const AdminReviewForm = lazy(() => import('./pages/admin/AdminReviewForm'));
const AdminPostsList = lazy(() => import('./pages/admin/AdminPostsList'));
const AdminPostForm = lazy(() => import('./pages/admin/AdminPostForm'));
const AdminCommentsList = lazy(() => import('./pages/admin/AdminCommentsList'));
const AdminAnalytics = lazy(() => import('./pages/admin/AdminAnalytics'));
const AdminPodcastList = lazy(() => import('./pages/admin/AdminPodcastList'));
const AdminPodcastForm = lazy(() => import('./pages/admin/AdminPodcastForm'));

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/resenas" element={<Resenas />} />
            <Route path="/resenas/:slug" element={<ReviewDetail />} />
            <Route path="/que-leer" element={<QueLeer />} />
            <Route path="/que-leer/:slug" element={<PostDetail />} />
            <Route path="/viajes-literarios" element={<ViajesLiterarios />} />
            <Route path="/ferias-eventos" element={<FeriasEventos />} />
            <Route path="/podcast" element={<Podcast />} />
            <Route path="/libros" element={<Libros />} />
            <Route path="/libros/:slug" element={<LibroDetail />} />
            <Route path="/autores" element={<Autores />} />
            <Route path="/autores/:slug" element={<AutorDetail />} />
            <Route path="/colaboraciones" element={<Colaboraciones />} />
            <Route path="/trabaja-conmigo" element={<TrabajaConmigo />} />
            <Route path="/media-kit" element={<MediaKit />} />
            <Route path="/sobre-mi" element={<SobreMi />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/buscar" element={<Buscar />} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/condiciones-de-uso" element={<CondicionesUso />} />
            <Route path="/politica-editorial" element={<PoliticaEditorial />} />
            <Route path="/politica-de-colaboraciones" element={<PoliticaColaboraciones />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          <Route
            path={`${ADMIN_BASE_PATH}/login`}
            element={<Suspense fallback={<div className="admin-loading">Cargando…</div>}><AdminLogin /></Suspense>}
          />
          <Route
            path={ADMIN_BASE_PATH}
            element={<Suspense fallback={<div className="admin-loading">Cargando…</div>}><AdminLayout /></Suspense>}
          >
            <Route index element={<AdminDashboard />} />
            <Route path="authors" element={<AdminAuthorsList />} />
            <Route path="authors/nuevo" element={<AdminAuthorForm />} />
            <Route path="authors/:id" element={<AdminAuthorForm />} />
            <Route path="books" element={<AdminBooksList />} />
            <Route path="books/nuevo" element={<AdminBookForm />} />
            <Route path="books/:id" element={<AdminBookForm />} />
            <Route path="reviews" element={<AdminReviewsList />} />
            <Route path="reviews/nuevo" element={<AdminReviewForm />} />
            <Route path="reviews/:id" element={<AdminReviewForm />} />
            <Route path="posts" element={<AdminPostsList />} />
            <Route path="posts/nuevo" element={<AdminPostForm />} />
            <Route path="posts/:id" element={<AdminPostForm />} />
            <Route path="comments" element={<AdminCommentsList />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="podcast" element={<AdminPodcastList />} />
            <Route path="podcast/nuevo" element={<AdminPodcastForm />} />
            <Route path="podcast/:id" element={<AdminPodcastForm />} />
          </Route>
        </Routes>
        <ToastContainer position="bottom-right" />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
